import { Suspense, lazy } from "react";

import ModalCadastro from "../components/modal-cadastro/ModalCadastro";
import Header from "../components/Header";
import Hero from "./new-lp-sections/Hero";
import useScroll from "../hooks/useScroll";

const QueroEconomizar = lazy(() => import("./new-lp-sections/QueroEconomizar"));
const ComoCadastrar = lazy(() => import("./new-lp-sections/ComoCadastrar"));
const FooterVariacao = lazy(() => import("./new-lp-sections/Footer"));
const PerguntasFrequentes = lazy(() =>
  import("./new-lp-sections/PerguntasFrequentes")
);

const Main = () => {
  const isScrolled = useScroll(50);

  return (
    <div className="overflow-hidden">
      <ModalCadastro open={false} />
      <Header />
      {/* Espaçamento para compensar o header fixo */}
      {/* {isScrolled && <div className="h-[5rem]" />} */}
      <Hero />
      <section id="quero-economizar">
        <Suspense
          fallback={<div className="text-center p-8">Carregando seção...</div>}
        >
          <QueroEconomizar />
        </Suspense>
      </section>
      <section id="como-cadastrar">
        <Suspense
          fallback={<div className="text-center p-8">Carregando seção...</div>}
        >
          <ComoCadastrar />
        </Suspense>
      </section>
      <section id="perguntas-frequentes">
        <Suspense
          fallback={<div className="text-center p-8">Carregando seção...</div>}
        >
          <PerguntasFrequentes />
        </Suspense>
      </section>
      <section id="footer">
        <Suspense
          fallback={<div className="text-center p-8">Carregando seção...</div>}
        >
          <FooterVariacao />
        </Suspense>
      </section>
    </div>
  );
};

export default Main;
